import { Pipe, PipeTransform } from '@angular/core';
import { ListFields } from '../components/listfields';

@Pipe({
  name: 'listFieldsSearchBy',
  standalone: false
})
export class ListFieldsSearchByPipe implements PipeTransform {

  /** Collects searchable list fields */
  transform(listfields: ListFields[]): ListFields[] {
    return listfields.filter((el: ListFields) => { return el.SearchBy });
  }

}
